import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { GetArticlesQuerySchema } from "@msuite/utils/schemas";
import type { ArticleList } from "@msuite/utils/types";
import { client } from "@/hono";

export function useArticles(query?: GetArticlesQuerySchema) {
	/** Query */
	const _query = useQuery({
		queryKey: ["articles", query ? JSON.stringify(query) : ""],
		queryFn: async () => {
			const response = await client.stock.articles.$get({ query });
			const data = await responseHandler(response);
			return data.articles as ArticleList;
		},
	});

	return {
		..._query,
		articles: (_query.data || []) as ArticleList,
	};
}
